import React from "react";
import PropTypes from "prop-types";
import { pure } from "recompose";
import styles from "./ConditionBadge.scss";
import classnames from "classnames";
import styled from "styled-components";

const InitialsWrapper = styled.div`
  white-space: nowrap;
`;

function ConditionBadge({ name, color, handleModal, className, combined }) {
  const conditionInitials =
    name &&
    name
      .split(" ")
      .map(string => string.charAt(0))
      .join("")
      .substr(0, 2);
  const conditionBadgeColor = color || "#3A3A3A";
  return (
    <div
      className={classnames("wbkv9-ConditionBadge", styles.conditionBadge, className)}
      style={{ color: `${conditionBadgeColor}`, border: `1px solid ${conditionBadgeColor}` }}
      onClick={handleModal}>
      <InitialsWrapper>
        {conditionInitials} {combined && " ."}
      </InitialsWrapper>
    </div>
  );
}

ConditionBadge.propTypes = {
  name: PropTypes.string,
  color: PropTypes.string,
  onClick: PropTypes.func,
};

export default pure(ConditionBadge);
